<app-modal-v2 #modal customClassName="diary-form-element-settings-modal">
  <div class="modal-content">

    <div class="modal-header">
      <h2 class="modal-title">{{ faq.id ? 'Update' : 'Add' }} Frequently Asked Questions</h2>

      <div class="culture-select">
        <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
      </div>
    </div>
    <div class="modal-body">
      <!-- Start: Culture Forms -->
      @for (cultureForm of cultureForms; track form) {
        <form [formGroup]="cultureForm" [ngClass]="{'visibility-hidden': cultureForm.value.culture !== form.value.selectedCulture}">
          <div class="form-group">
            <label for="question">Question</label>
            <textarea class="question" formControlName="question" placeholder="Enter your question..."></textarea>
          </div>

            @if (form.value.selectedCulture === cultureForm.value.culture) {
                <div class="form-group">
                    <label for="answer">Answer</label>
                    <app-editor formControlName="answer"></app-editor>
                </div>
            }
        </form>
      }
      <!-- End: Culture Forms -->

      <!-- Start: Default Form -->
      <form [formGroup]="form" [class.visibility-hidden]="form.value.selectedCulture !== 'en'">
        <div class="form-group">
          <label for="question">Question</label>
          <textarea class="question" formControlName="question" placeholder="Enter your question..."></textarea>
        </div>
        <div class="form-group">
          <label for="answer">Answer</label>
            <app-editor formControlName="answer"></app-editor>
        </div>
      </form>
      <!-- End: Default Form -->
    </div>

    <div class="modal-footer">
      <div class="modal-footer-buttons">
        <app-button text="Cancel" variant="secondary" width="fill"
                    type="button" (click)="modal.hide()"/>

        <app-button text="Save" variant="primary" width="fill" [isBusy]="form.value.isBusy"
                    [disabled]="!form.valid"
                    type="button"
                    (click)="onSubmitForm()"/>
      </div>
    </div>

  </div>
</app-modal-v2>
